<template>
  <div class="certificate-wrap" :class="[certData.color]">
    <div class="certificate">
      <svg
        width="842"
        height="595"
        viewBox="0 0 842 595"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1458_42169)">
          <rect width="842" height="595" fill="#F8F8F8" />
          <rect
            x="8"
            y="8"
            width="826"
            height="579"
            stroke="var(--border)"
            stroke-width="16"
          />
          <g clip-path="url(#clip1_4910_176007)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M774.375 61.8589C774.351 61.8154 774.329 61.7749 774.303 61.7344C771.543 57.011 775.033 54.1037 777.752 51.8386L777.755 51.8354C778.545 51.1814 779.267 50.5774 779.756 50C779.774 50.0294 779.789 50.0572 779.805 50.084C779.824 50.119 779.843 50.1523 779.865 50.1856V50.1944C782.628 54.9112 779.134 57.819 776.409 60.0845C775.619 60.7386 774.898 61.3425 774.409 61.92L774.395 61.8953L774.375 61.8589ZM773.408 63.1173L773.408 63.1174L773.408 63.1174C773.368 63.1285 773.328 63.1395 773.289 63.1514C768.008 64.5946 766.105 60.4789 764.614 57.2562L764.613 57.2533C764.183 56.3253 763.782 55.468 763.352 54.8522C763.382 54.8436 763.411 54.8355 763.439 54.8274L763.44 54.8274C763.48 54.8163 763.519 54.8053 763.558 54.7933H763.567C768.841 53.3586 770.753 57.4802 772.237 60.6914C772.665 61.6195 773.065 62.4679 773.495 63.0925C773.466 63.1012 773.437 63.1093 773.408 63.1173ZM779.838 59.2655C779.812 59.225 779.79 59.1844 779.766 59.141L779.75 59.1118L779.732 59.0799C779.243 59.6573 778.521 60.2613 777.732 60.9153C775.007 63.1809 771.513 66.0887 774.276 70.7936V70.8025C774.302 70.843 774.325 70.8836 774.348 70.927C774.359 70.9467 774.37 70.9669 774.382 70.9881C774.871 70.4107 775.593 69.8067 776.383 69.1527C779.108 66.8989 782.602 63.9911 779.838 59.2655ZM686.715 69.2499C684.411 69.2499 682.955 70.7141 682.955 72.7558H690.306C690.306 70.6257 688.765 69.2499 686.715 69.2499ZM679.394 74.0167C679.394 69.3884 682.399 66.0298 686.715 66.0298C690.892 66.0298 693.812 69.6712 693.815 74.7149V75.419H682.958C682.958 77.4902 684.072 79.1694 686.794 79.1694C688.394 79.1694 689.458 78.5243 690.044 77.4902L693.217 78.4477C692.124 80.8782 689.625 82.3925 686.794 82.3925C682.372 82.3925 679.394 78.645 679.394 74.0167ZM698.526 70.3753H698.243V67.1817H694.934V81.8828H698.243V75.4691C698.243 74.6295 698.437 73.6249 698.635 73.0592C699.339 71.047 700.626 70.0925 702.082 70.0925H704.492V66.8694H702.635C701.027 66.8694 699.395 68.2747 698.526 70.3753ZM710.21 74.1817C710.21 76.9834 711.648 79.1989 713.775 79.1989C715.934 79.1989 717.36 76.9834 717.366 74.1817C717.366 71.3799 715.914 69.1939 713.775 69.1939C711.636 69.1939 710.21 71.3799 710.21 74.1817ZM709.509 69.9746C710.125 67.6001 712.057 66.0298 714.361 66.0298C718.209 66.0298 720.786 69.0849 720.784 73.6455C720.784 78.8778 718.315 82.3837 714.614 82.3837C712.087 82.3837 710.045 80.6455 709.509 78.0087H709.226V81.874H705.917V61.0126H709.226V69.9746H709.509ZM742.564 65.2402H745.876V61.2954H742.564V65.2402ZM745.876 81.8858H742.564V67.1817H745.876V81.8858ZM749.573 81.8858H752.873V69.898H756.573V66.9608H752.873V64.0235C752.873 63.6051 752.931 63.4078 753.294 63.4078H757.365V60.2436H753.918C750.775 60.2436 749.573 61.4162 749.573 64.5008V66.9608H747.269V69.898H749.573V81.8858ZM764.141 69.2499C761.838 69.2499 760.382 70.7141 760.382 72.7558H767.733C767.733 70.6257 766.192 69.2499 764.141 69.2499ZM756.82 74.0167C756.82 69.3884 759.825 66.0298 764.141 66.0298C768.319 66.0298 771.239 69.6712 771.23 74.7149V75.419H760.373C760.373 77.4902 761.496 79.1694 764.221 79.1694C765.821 79.1694 766.884 78.5243 767.471 77.4902L770.644 78.4477C769.551 80.8782 767.052 82.3925 764.221 82.3925C759.799 82.3925 756.82 78.645 756.82 74.0167ZM731.31 75.4014C731.31 77.4136 729.875 78.7599 727.719 79.0133C726.537 79.1488 724.77 78.7599 724.77 77.499C724.77 76.6594 725.326 75.7313 727.601 75.4574L731.301 74.9801L731.31 75.4014ZM740.888 81.9211V61.0627H737.579V78.81H735.343C734.632 78.81 734.635 78.2444 734.639 77.7394V77.7386C734.639 77.7045 734.639 77.6708 734.639 77.6375V70.9999C734.639 67.9742 732.285 65.962 728.723 65.962C725.159 65.962 722.643 67.6119 722.162 70.3842L725.58 71.0294C725.942 69.8774 727.124 69.1851 728.723 69.1851C730.323 69.1851 731.331 69.9157 731.331 70.9999V72.2019L727.66 72.7293C723.17 73.3745 721.352 75.0832 721.352 77.5992C721.352 80.6838 723.736 82.3041 727.297 82.3041C729.875 82.3041 732.032 80.6838 732.686 78.2709H732.969V78.5537C732.969 81.2082 733.876 81.9211 736.327 81.9211H740.888ZM667.035 69.8097H675.078V61.0214H678.386V81.874H675.078V72.8147H667.035V81.874H663.723V61.0214H667.035V69.8097Z"
              fill="#266431"
            />
            <path
              d="M647.225 95.0814H594.074C593.405 95.0814 592.866 94.5393 592.866 93.8735V61.4515C592.866 60.7828 593.408 60.2436 594.074 60.2436H647.228C647.897 60.2436 648.436 60.7857 648.436 61.4515V93.8735C648.436 94.5422 647.894 95.0814 647.225 95.0814Z"
              fill="white"
              stroke="black"
              stroke-width="1.80293"
              stroke-miterlimit="10"
            />
            <path
              d="M625.33 95.0814H620.648H615.967L613.701 102.279C613.58 102.659 613.922 103.03 614.385 103.03H620.645H626.906C627.371 103.03 627.71 102.659 627.589 102.279L625.33 95.0814Z"
              fill="white"
              stroke="black"
              stroke-width="1.80293"
              stroke-miterlimit="10"
            />
            <path
              d="M644.255 88.2612H597.044C596.791 88.2612 596.584 88.0549 596.584 87.8016V63.7495C596.584 63.4961 596.791 63.2899 597.044 63.2899H644.258C644.512 63.2899 644.718 63.4961 644.718 63.7495V87.8016C644.715 88.0549 644.509 88.2612 644.255 88.2612Z"
              fill="#3C9187"
              stroke="black"
              stroke-width="1.80293"
              stroke-miterlimit="10"
            />
            <path
              d="M628.883 74.1817V78.6097C628.883 81.9358 625.194 84.6315 620.642 84.6315C616.091 84.6315 612.402 81.9358 612.402 78.6097V74.1817"
              fill="white"
            />
            <path
              d="M628.883 74.1817V78.6097C628.883 81.9358 625.194 84.6315 620.642 84.6315C616.091 84.6315 612.402 81.9358 612.402 78.6097V74.1817"
              stroke="black"
              stroke-width="1.80293"
              stroke-miterlimit="10"
            />
            <path
              d="M605.131 70.6257L620.212 79.0811C620.533 79.2608 620.925 79.2608 621.246 79.0811L629.333 74.5411L636.177 70.6316C636.887 70.225 636.887 69.1998 636.174 68.7962L621.202 60.4115C620.801 60.1876 620.309 60.1876 619.909 60.4145L605.125 68.7873C604.409 69.191 604.412 70.2221 605.131 70.6257Z"
              fill="white"
              stroke="black"
              stroke-width="1.80293"
              stroke-miterlimit="10"
            />
            <path
              d="M617.095 67.4704L607.709 72.5436V82.6576"
              stroke="black"
              stroke-width="1.80293"
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M704.02 97.179H703.11H703.107V101.413H705.264V99.0704H712.741V101.413H714.897V97.1761H713.713V88.818H705.508V90.4118C705.508 91.169 705.49 91.8731 705.455 92.5242C705.42 93.1753 705.349 93.7763 705.243 94.3331C705.137 94.8899 704.984 95.4025 704.786 95.871C704.589 96.3423 704.336 96.7754 704.02 97.179ZM711.33 90.674V97.179H706.586C706.831 96.7695 707.031 96.3394 707.187 95.8945C707.344 95.4467 707.467 94.9694 707.553 94.4568C707.638 93.9442 707.7 93.3933 707.735 92.7982C707.771 92.206 707.788 91.5579 707.788 90.8596V90.674H711.33ZM671.112 88.8209L676.012 99.0763H673.46L672.411 96.7931H667.191L666.127 99.0763H663.726L668.667 88.8209H671.112ZM671.628 95.1109L669.804 91.1866L667.969 95.1109H671.628ZM680.004 88.8209H677.714V99.0793H680.004V95.5557L681.695 94.0768L685.61 99.0469H688.483L683.33 92.6037L687.599 88.8209H684.405L680.004 93.0309V88.8209ZM701.808 99.0763L696.908 88.8209H694.463L689.522 99.0763H691.924L692.987 96.7931H698.208L699.256 99.0763H701.808ZM695.6 91.1866L697.424 95.1109H693.765L695.6 91.1866ZM747.075 88.8209H749.446V95.9299H749.491L755.639 88.8209H758.314V99.0763H755.943V91.9526L749.75 99.0763H747.075V88.8209ZM761.941 93.9825C762.383 94.5069 762.963 94.8545 763.682 95.0254L760.394 99.0734H763.373L766.26 95.211H768.852V99.0734H771.224V88.818H765.002C764.507 88.818 764.033 88.8769 763.582 88.9977C763.131 89.1185 762.736 89.307 762.398 89.5663C762.059 89.8226 761.788 90.1496 761.584 90.5414C761.381 90.9333 761.281 91.4046 761.281 91.9497C761.281 92.7834 761.499 93.461 761.941 93.9825ZM768.858 90.5886V93.5288H765.703C765.429 93.5288 765.167 93.5082 764.914 93.464C764.66 93.4198 764.436 93.3402 764.245 93.2195C764.053 93.1016 763.897 92.9396 763.782 92.7393C763.667 92.5389 763.608 92.2797 763.608 91.9644C763.608 91.6698 763.664 91.4312 763.776 91.2544C763.888 91.0776 764.036 90.9392 764.224 90.839C764.413 90.7388 764.625 90.6711 764.863 90.6387C765.102 90.6063 765.347 90.5886 765.6 90.5886H768.858ZM717.599 88.8209H727.389V90.7182H720.474V92.9131H726.823V94.6631H720.474V97.182H727.536V99.0793H717.599V88.8209ZM733.629 88.8209H730.064V99.0793H732.427V91.4872L732.444 90.783L735.782 99.0793H738.178L741.636 90.783V99.0763H743.975V88.8209H740.278L736.934 96.7136L733.629 88.8209Z"
              fill="#3C9187"
            />
          </g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M170.791 525.205C170.767 525.161 170.744 525.12 170.717 525.079C167.923 520.295 171.457 517.351 174.21 515.057L174.214 515.054C175.014 514.392 175.745 513.78 176.24 513.195C176.258 513.224 176.273 513.252 176.289 513.279L176.289 513.279L176.289 513.28L176.289 513.28L176.29 513.28L176.29 513.281L176.29 513.281L176.29 513.281L176.29 513.281L176.29 513.281L176.29 513.282C176.31 513.316 176.329 513.35 176.35 513.383V513.392C179.149 518.169 175.611 521.114 172.851 523.408C172.051 524.07 171.32 524.682 170.825 525.267L170.813 525.245L170.791 525.205ZM169.811 526.479C169.771 526.491 169.731 526.502 169.691 526.514C164.343 527.975 162.415 523.807 160.906 520.544L160.904 520.541C160.469 519.601 160.063 518.733 159.627 518.109C159.657 518.1 159.687 518.092 159.716 518.084C159.756 518.073 159.796 518.062 159.836 518.049H159.845C165.186 516.596 167.122 520.77 168.626 524.023C169.058 524.962 169.464 525.822 169.9 526.454C169.87 526.463 169.84 526.471 169.811 526.479L169.811 526.479ZM176.324 522.579C176.297 522.537 176.274 522.496 176.25 522.452L176.233 522.422L176.216 522.391C175.721 522.975 174.99 523.587 174.19 524.249C171.43 526.544 167.892 529.489 170.691 534.253V534.262C170.717 534.303 170.739 534.344 170.763 534.388L170.763 534.388L170.763 534.388L170.764 534.388L170.764 534.388L170.764 534.389L170.764 534.39C170.775 534.409 170.786 534.429 170.798 534.45C171.293 533.866 172.024 533.254 172.824 532.592C175.584 530.309 179.122 527.364 176.324 522.579ZM82.0143 532.69C79.6811 532.69 78.2072 534.173 78.2072 536.241H85.6513C85.6513 534.083 84.0909 532.69 82.0143 532.69ZM74.6 537.518C74.6 532.83 77.6433 529.429 82.0143 529.429C86.2451 529.429 89.2018 533.117 89.2048 538.225V538.938H78.2102C78.2102 541.035 79.338 542.736 82.0948 542.736C83.7149 542.736 84.792 542.083 85.3858 541.035L88.5991 542.005C87.4922 544.466 84.9621 546 82.0948 546C77.6164 546 74.6 542.205 74.6 537.518ZM93.9756 533.83H93.6892V530.596H90.3386V545.484H93.6892V538.988C93.6892 538.138 93.8861 537.121 94.086 536.548C94.7991 534.51 96.103 533.543 97.5769 533.543H100.017V530.279H98.1378C96.5087 530.279 94.8558 531.702 93.9756 533.83ZM105.809 537.685C105.809 540.522 107.265 542.766 109.419 542.766C111.606 542.766 113.05 540.522 113.056 537.685C113.056 534.847 111.585 532.633 109.419 532.633C107.253 532.633 105.809 534.847 105.809 537.685ZM105.099 533.424C105.722 531.019 107.679 529.429 110.013 529.429C113.909 529.429 116.52 532.523 116.517 537.142C116.517 542.441 114.017 545.991 110.269 545.991C107.709 545.991 105.642 544.231 105.099 541.56H104.812V545.475H101.462V524.348H104.812V533.424H105.099ZM138.575 528.629H141.928V524.634H138.575V528.629ZM141.928 545.487H138.575V530.596H141.928V545.487ZM145.673 545.487H149.015V533.346H152.762V530.372H149.015V527.397C149.015 526.973 149.074 526.774 149.441 526.774H153.565V523.569H150.074C146.89 523.569 145.673 524.757 145.673 527.88V530.372H143.34V533.346H145.673V545.487ZM160.427 532.69C158.094 532.69 156.62 534.173 156.62 536.241H164.064C164.064 534.083 162.503 532.69 160.427 532.69ZM153.013 537.518C153.013 532.83 156.056 529.429 160.427 529.429C164.658 529.429 167.614 533.117 167.605 538.225V538.938H156.611C156.611 541.035 157.748 542.736 160.507 542.736C162.128 542.736 163.205 542.083 163.798 541.035L167.012 542.005C165.905 544.466 163.375 546 160.507 546C156.029 546 153.013 542.205 153.013 537.518ZM127.177 538.92C127.177 540.958 125.724 542.321 123.54 542.578C122.344 542.715 120.554 542.321 120.554 541.044C120.554 540.194 121.118 539.254 123.421 538.977L127.168 538.493L127.177 538.92ZM136.877 545.523V524.399H133.527V542.372H131.262C130.541 542.372 130.545 541.799 130.548 541.288C130.549 541.272 130.549 541.257 130.549 541.242C130.549 541.223 130.549 541.203 130.549 541.184V534.462C130.549 531.398 128.165 529.36 124.558 529.36C120.948 529.36 118.4 531.031 117.913 533.839L121.374 534.492C121.741 533.326 122.938 532.624 124.558 532.624C126.178 532.624 127.198 533.364 127.198 534.462V535.68L123.481 536.214C118.934 536.867 117.093 538.598 117.093 541.146C117.093 544.27 119.506 545.91 123.114 545.91C125.724 545.91 127.908 544.269 128.571 541.826H128.857V542.112C128.857 544.801 129.776 545.523 132.258 545.523H136.877ZM62.0837 533.257H70.229V524.357H73.5796V545.475H70.229V536.3H62.0837V545.475H58.7301V524.357H62.0837V533.257Z"
            fill="#266431"
          ></path>
          <path
            d="M-37 308L255.755 27.1875H-37V308Z"
            fill="url(#paint0_linear_1458_42169)"
          />
          <path
            d="M-36.9995 85.8105L479.03 -9H-36.9995V85.8105Z"
            fill="url(#paint1_linear_1458_42169)"
          />
          <path
            d="M-36.9995 271.813L255.755 -9H-36.9995V271.813Z"
            fill="url(#paint2_linear_1458_42169)"
          />
          <path
            d="M-36.9995 73.8687L167.458 -9H-36.9995V73.8687Z"
            fill="var(--triangle1)"
          />
          <path
            d="M844.97 448L551.97 644H844.97V448Z"
            fill="url(#paint3_linear_1458_42169)"
          />
          <path
            d="M844.97 473L551.97 669H844.97V473Z"
            fill="url(#paint4_linear_1458_42169)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1458_42169"
            x1="109.377"
            y1="27.1875"
            x2="-10.9452"
            y2="308"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="var(--triangle-2-start)" />
            <stop offset="1" stop-color="var(--triangle-2-end)" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1458_42169"
            x1="345.861"
            y1="-24.9224"
            x2="184.828"
            y2="49.9851"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="var(--triangle-3-start)" />
            <stop offset="1" stop-color="var(--triangle-3-end)" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_1458_42169"
            x1="109.378"
            y1="-9"
            x2="-25.4196"
            y2="262.404"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="var(--triangle-4-start)" />
            <stop
              offset="1"
              stop-color="var(--triangle-4-end)"
              stop-opacity="0"
            />
          </linearGradient>
          <linearGradient
            id="paint3_linear_1458_42169"
            x1="698.47"
            y1="644"
            x2="762.109"
            y2="431.032"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="var(--triangle-5-start)" />
            <stop offset="1" stop-color="var(--triangle-5-end)" />
          </linearGradient>
          <linearGradient
            id="paint4_linear_1458_42169"
            x1="698.47"
            y1="669"
            x2="771.507"
            y2="458.136"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="var(--triangle-6-start)" />
            <stop
              offset="1"
              stop-color="var(--triangle-6-end)"
              stop-opacity="0"
            />
          </linearGradient>
          <clipPath id="clip0_1458_42169">
            <rect width="842" height="595" fill="white" />
          </clipPath>
          <clipPath id="clip1_4910_176007">
            <rect
              width="189.43"
              height="53.7646"
              fill="white"
              transform="translate(592.146 50)"
            />
          </clipPath>
        </defs>
      </svg>
      <div class="certificate__inner font_helvetica font_white">
        <div class="certificate__year">2024</div>
        <h2 class="certificate__event-title">{{ certData.name }}</h2>
        <h2 class="certificate__header">
          {{ $t("certificate_template.header") }}
        </h2>
        <span class="certificate__FIO">{{ certData.username }}</span>
        <span class="certificate__caption">
          {{ $t("certificate_template.caption_1") }} <br />«{{ certData.name }}»
          <!-- <br />
          {{ $t('certificate_template.caption_2') }} -->
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CertificateTemplate",
  props: {
    certData: Object,
  },
};
</script>

<style lang="scss" scoped>
.certificate {
  position: fixed;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  display: block;
  width: 842px;
  height: 595px;
  box-sizing: border-box;
  // background: #075f49;
  opacity: 1;
  visibility: visible;

  & svg {
    position: absolute;
    top: 0;
    left: 0;
  }

  &-wrap {
    opacity: 0;
    visibility: hidden;
    z-index: -1;
    position: fixed;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    width: 842px;
    height: 595px;
  }

  &__inner {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 2;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }

  &__header {
    font-family: "Noto-Sans";
    font-style: normal;
    font-weight: 300;
    font-size: 96px;
    line-height: 112px;
    color: #25282a;
  }

  &__year {
    padding: 0px 10px 10px;
    margin-top: 143px;
    font-family: "Noto-Sans";
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    text-align: center;
    color: var(--date-color);
    background: var(--date-bg-color);
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__event-title {
    margin-top: 15px;
    font-family: "Noto-Sans";
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    color: var(--title-color);
  }

  &__FIO {
    margin-bottom: 8px;
    margin-top: 21px;
    font-family: "Noto-Sans";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    text-align: center;
    color: #25282a;
  }

  &__caption {
    font-family: "Noto-Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 26px;
    text-align: center;
    color: #54585a;
    display: block;
    max-width: 600px;
  }

  &__logo-row {
    margin-top: 31px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: auto;
  }

  &__logo-left {
    display: block;
    width: 132px;
    height: 27px;
    object-fit: cover;
    object-position: center;
  }

  &__logo-center {
    margin-left: 20px;
    display: block;
    width: 36px;
    height: 24px;
    object-fit: cover;
    object-position: center;
  }

  &__img-right {
    margin-left: 8.5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }

  &__logo-right {
    display: block;
    width: 127px;
    height: 11px;
    object-fit: cover;
    object-position: center;
  }

  &__logo-text {
    margin-top: 5.5px;
    font-size: 7.6px;
    line-height: 9px;
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }
}
</style>
